import { render, staticRenderFns } from "./global-component.vue?vue&type=template&id=2918253a&"
import script from "./global-component.vue?vue&type=script&lang=js&"
export * from "./global-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports